import React, {useContext, useState} from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  Button
} from '@material-ui/core';
import {Trans} from 'react-i18next';
import {LoanConfigurationContext} from '../../loan-configurations/loan-configuration/LoanConfiguration';
import {ExternalCustomFieldConfig} from './ExternalCustomFieldSelection';

interface Props {
  externalCustomFieldConfigs: ExternalCustomFieldConfig[];
  externalCustomFieldConfigId?: number;
  onSelectionChange: (id?: number) => void;
}

export function ExternalCustomFieldSelectableList({
                                                    externalCustomFieldConfigs,
                                                    externalCustomFieldConfigId: initialExternalCustomFieldConfigId,
                                                    onSelectionChange
                                                  }: Props): React.ReactElement {
  const [externalCustomFieldConfigId, setExternalCustomFieldConfigId] = useState<number | undefined>(initialExternalCustomFieldConfigId);
  const {externalCustomFields, addExternalCustomField, removeExternalCustomField} = useContext(LoanConfigurationContext);

  const handleToggle = (id?: number) => () => {
    setExternalCustomFieldConfigId(id);

  };

  const handleSave = () => {
    // Add new selection
    if (externalCustomFieldConfigId) {
      addExternalCustomField(externalCustomFieldConfigId);
    }

    // Remove old selection
    if (initialExternalCustomFieldConfigId) {
      removeExternalCustomField(initialExternalCustomFieldConfigId);
    }

    //call parent selection change
    onSelectionChange(externalCustomFieldConfigId);
  };

  const handleReset = () => {
    removeExternalCustomField(initialExternalCustomFieldConfigId);
    setExternalCustomFieldConfigId(undefined);
    onSelectionChange(undefined);
  };

  // Filter out already used external custom fields
  const availableExternalCustomFieldConfigs = externalCustomFieldConfigs.filter(
    config => !externalCustomFields.includes(config.id) || config.id === initialExternalCustomFieldConfigId
  );

  return (
    <div>
      <List>
        {availableExternalCustomFieldConfigs.map((item) => {
          const key = item.id;
          const label = `${item.name} (${item.fieldType})`;
          const labelId = `radio-list-label-${key}`;
          const isSelected = externalCustomFieldConfigId === key;

          return (
            <ListItem
              key={item.id}
              role={undefined}
              dense
              button
              onClick={handleToggle(key)}
            >
              <ListItemIcon>
                <Radio
                  edge="start"
                  checked={isSelected}
                  tabIndex={-1}
                  inputProps={{'aria-labelledby': labelId}}
                />
              </ListItemIcon>
              <ListItemText
                id={labelId}
                primary={label}
                secondary={
                  item.categories && item.categories.length > 0 ? (
                    <>
                      {item.categories.slice(0, 3).map((category, index, displayedCategories) => (
                        <span key={category.id || index}> {category.name} {index < displayedCategories.length - 1
                          ? ' • '
                          : ''}</span>
                      ))}
                    </>
                  ) : null
                }
              />

            </ListItem>
          );
        })}
      </List>

      <div>
        <Button onClick={handleReset}>
          <Trans>COMMON.RESET</Trans>
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleSave}
        >
          <Trans>COMMON.SAVE</Trans>
        </Button>
      </div>
    </div>
  );
}